import '.a{display:flex;}.ssr-plugin'
import '.ac{align-items:stretch;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ch{background:var(--shades-white);}.ssr-plugin'
import '.cv{flex-grow:1;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.ao{max-width:77.5rem;}.ssr-plugin'
import '.d8{justify-content:stretch;}.ssr-plugin'
import '.d9{position:sticky;}.ssr-plugin'
import '.cq{top:0;}.ssr-plugin'
import '.da{z-index:10;}.ssr-plugin'
import '.db{padding-block:1rem;}.ssr-plugin'
import '.dc{height:3rem;}.ssr-plugin'
import '.a7{justify-content:space-between;}.ssr-plugin'
import '.dd{flex-wrap:wrap;}.ssr-plugin'
import '.de{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.am{margin-top:2rem;}.ssr-plugin'
import '.df{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ac b e ch"
      >
        <div className="cv a f b e"
        >
          <div className="ao a e d8 d9 cq da ch"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="db dc a a7 f dd"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="de a e ac am df ao"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
